const categoryType = {
    Fee: 'fee',
    Income: 'income',
    Expense: 'expense',
    Exam: 'exam',
}
export default categoryType
